var map = {
	"./ACGIH-Heavy": 398,
	"./ACGIH-Heavy.json": 398,
	"./ACGIH-Light": 399,
	"./ACGIH-Light.json": 399,
	"./ACGIH-Moderate": 400,
	"./ACGIH-Moderate.json": 400,
	"./ACSM-Acclimatized": 401,
	"./ACSM-Acclimatized.json": 401,
	"./ACSM-NonAcclimatized": 402,
	"./ACSM-NonAcclimatized.json": 402,
	"./GaStateHighSchool": 403,
	"./GaStateHighSchool.json": 403,
	"./KyStateHighSchool": 404,
	"./KyStateHighSchool.json": 404,
	"./NATA": 405,
	"./NATA.json": 405,
	"./NcStateHighSchool": 406,
	"./NcStateHighSchool.json": 406,
	"./NjStateHighSchool": 407,
	"./NjStateHighSchool.json": 407,
	"./TBMed507-Easy": 408,
	"./TBMed507-Easy.json": 408,
	"./TBMed507-Hard": 409,
	"./TBMed507-Hard.json": 409,
	"./TBMed507-Moderate": 410,
	"./TBMed507-Moderate.json": 410,
	"./UsaSoccer-Cat1": 411,
	"./UsaSoccer-Cat1.json": 411,
	"./UsaSoccer-Cat2": 412,
	"./UsaSoccer-Cat2.json": 412,
	"./UsaSoccer-Cat3": 413,
	"./UsaSoccer-Cat3.json": 413,
	"./VtStateHighSchool": 414,
	"./VtStateHighSchool.json": 414,
	"./_HeatStressGuidelinesIndex": 319,
	"./_HeatStressGuidelinesIndex.json": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 604;